var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClients(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_11",
    "data-name": "Rectangle 11",
    width: 16,
    height: 16,
    transform: "translate(1 1)",
    fill: "none",
    stroke: "#505050",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-Clients"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Clients",
    clipPath: "url(#clip-Clients)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15",
    "data-name": "Group 15",
    transform: "translate(-1 -1)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7",
    "data-name": "Path 7",
    d: "M8.434,8.945c1.991,0,2.985-2.21,2.985-4.5,0-1.657-.229-2.6-.918-3.235A2.655,2.655,0,0,0,8.358.5C6.981.521,5.3,1.132,5.3,3.894c0,3,1.225,5.051,3.138,5.051",
    transform: "translate(0.508 1.87)",
    fill: "none",
    stroke: "#505050",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8",
    "data-name": "Path 8",
    d: "M13.782,16.574H.5V15.48a4.508,4.508,0,0,1,4.057-3.957l1.159-.176",
    transform: "translate(1.859 -0.944)",
    fill: "none",
    stroke: "#505050",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9",
    "data-name": "Path 9",
    d: "M14.48,11.827A4.392,4.392,0,0,1,17.72,15.6V16.7",
    transform: "translate(-2.078 -1.069)",
    fill: "none",
    stroke: "#505050",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10",
    "data-name": "Path 10",
    d: "M8.5,11.922l-.41,1.267a.24.24,0,0,0,.1.279l.672.4-.833,2.742",
    transform: "translate(-0.263 -1.094)",
    fill: "none",
    stroke: "#505050",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11",
    "data-name": "Path 11",
    d: "M11.008,11.922l.41,1.267a.24.24,0,0,1-.1.279l-.672.4.833,2.742",
    transform: "translate(-0.998 -1.094)",
    fill: "none",
    stroke: "#505050",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_6",
    "data-name": "Line 6",
    x2: 0.888,
    transform: "translate(8.682 12.841)",
    fill: "none",
    stroke: "#505050",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClients);
export default __webpack_public_path__ + "static/media/Clients.110e31ad87e2861b709b615be32f2557.svg";
export { ForwardRef as ReactComponent };